import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import RefreshIcon from "@material-ui/icons/Refresh";
import FlaggedPlayersTable from "./FlaggedPlayersTable";
import PlayerDrillIn from "./PlayerDrillIn";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(4),
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  title: {
    fontSize: "1.35rem",
    fontWeight: 700,
  },
  subtitle: {
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(6),
  },
  errorBox: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
    borderRadius: theme.spacing(0.5),
    marginBottom: theme.spacing(2),
  },
  steamIdDisplay: {
    fontFamily: "monospace",
    fontSize: "0.9rem",
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(1),
  },
}));

export default function AnticheatDashboard({
  loading,
  error,
  flaggedPlayers,
  selectedPlayer,
  selectedPlayerSummary,
  selectedPlayerObservations,
  onSelectPlayer,
  onClearPlayer,
  onRefresh,
}) {
  const classes = useStyles();

  return (
    <Container maxWidth="lg" className={classes.root}>
      <div className={classes.header}>
        <div className={classes.headerLeft}>
          {selectedPlayer && (
            <Button
              size="small"
              startIcon={<ArrowBackIcon />}
              onClick={onClearPlayer}
              className={classes.backButton}
            >
              Back
            </Button>
          )}
          <Typography className={classes.title}>
            Anticheat Dashboard
          </Typography>
          {selectedPlayer && (
            <Typography className={classes.steamIdDisplay}>
              {selectedPlayer}
            </Typography>
          )}
        </div>
        {!selectedPlayer && (
          <Button
            size="small"
            startIcon={<RefreshIcon />}
            onClick={onRefresh}
            disabled={loading}
          >
            Refresh
          </Button>
        )}
      </div>

      {!selectedPlayer && (
        <Typography className={classes.subtitle}>
          Players flagged by behavioral analysis from collected telemetry data.
        </Typography>
      )}

      {error && (
        <div className={classes.errorBox}>
          <Typography variant="body2">{error}</Typography>
        </div>
      )}

      {loading && !flaggedPlayers.length && !selectedPlayer ? (
        <div className={classes.loading}>
          <CircularProgress size={32} />
        </div>
      ) : selectedPlayer ? (
        <PlayerDrillIn
          steamId={selectedPlayer}
          summary={selectedPlayerSummary}
          batches={selectedPlayerObservations}
        />
      ) : (
        <FlaggedPlayersTable
          players={flaggedPlayers}
          onSelectPlayer={onSelectPlayer}
        />
      )}
    </Container>
  );
}
